var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box, Typography } from "@mui/material";
import { Edit, FormDataConsumer, ReferenceField, ReferenceInput, SelectInput, SimpleForm, TextField, TextInput, } from "react-admin";
import { ListBallotStyle } from "./ListBallotStyle";
import { JsonInput } from "react-admin-json-view";
var BallotStyleForm = function () {
    return (_jsx(Box, __assign({ sx: { flexGrow: 2, flexShrink: 0 } }, { children: _jsxs(SimpleForm, { children: [_jsx(Typography, __assign({ variant: "h4" }, { children: "Ballot Style" })), _jsx(Typography, __assign({ variant: "body2" }, { children: "Ballot Style configuration" })), _jsx(Typography, __assign({ variant: "h5" }, { children: "ID" })), _jsx(TextField, { source: "id" }), _jsx(TextInput, { source: "ballot_eml" }), _jsx(TextInput, { source: "status" }), _jsx(Typography, __assign({ variant: "h5" }, { children: "Election" })), _jsx(ReferenceField, __assign({ label: "Election", reference: "sequent_backend_election", source: "election_id" }, { children: _jsx(TextField, { source: "name" }) })), _jsx(Typography, __assign({ variant: "h5" }, { children: "Election Event" })), _jsx(ReferenceField, __assign({ label: "Election Event", reference: "sequent_backend_election_event", source: "election_event_id" }, { children: _jsx(TextField, { source: "name" }) })), _jsx(FormDataConsumer, { children: function (_a) {
                        var formData = _a.formData;
                        return (_jsx(ReferenceInput, __assign({ source: "area_id", reference: "sequent_backend_area", filter: {
                                tenant_id: formData.tenant_id,
                                election_event_id: formData.election_event_id,
                            } }, { children: _jsx(SelectInput, { optionText: "name" }) })));
                    } }), _jsx(JsonInput, { source: "labels", jsonString: false, reactJsonOptions: {
                        name: null,
                        collapsed: true,
                        enableClipboard: true,
                        displayDataTypes: false,
                    } }), _jsx(JsonInput, { source: "annotations", jsonString: false, reactJsonOptions: {
                        name: null,
                        collapsed: true,
                        enableClipboard: true,
                        displayDataTypes: false,
                    } }), _jsx(JsonInput, { source: "status", jsonString: false, reactJsonOptions: {
                        name: null,
                        collapsed: true,
                        enableClipboard: true,
                        displayDataTypes: false,
                    } })] }) })));
};
export var EditBallotStyle = function () {
    return (_jsx(ListBallotStyle, { aside: _jsx(Edit, __assign({ sx: { flexGrow: 2, width: "50%", flexShrink: 0 } }, { children: _jsx(BallotStyleForm, {}) })) }));
};
